import styled, { css } from 'styled-components';
import Select from 'react-select';
import ThemedTooltip from '../../../../../../theme/ThemedTooltip';
import { ReactComponent as Sorted } from '../../../../../../assets/img/sort-arrows.svg';
import { InfoDark } from '../../../../../../globalStyled';
import { themedSelectMenuCss } from '../../../../../../theme/selectStyles';
import { svgCenteredText } from '../../../../../../theme/typography';

export const StyledCellName = styled.p`
  color: ${({ theme }) => theme.textFaint};
  padding: 7px 0;
`;
export const StyledCell = styled.span`
  font-size: 11px;
  font-weight: 500;
  font-family: 'Archivo', sans-serif;
  color: ${({ theme }) => theme.text};
`;
export const InfoDarkAbsolute = styled(InfoDark)`
  position: relative;
  top: 0;
  left: 2px;
  display: inline-block;
  vertical-align: middle;
`;

export const StyledNumberWrap = styled.span`
  position: relative;
  display: inline-flex;
`;

export const StyledCircleText = styled.text.attrs({
  textAnchor: 'middle',
  dy: '0.35em',
})`
  ${svgCenteredText};
  fill: ${({ theme }) => theme.text};
  font-family: 'Archivo', sans-serif;
  font-weight: 600;
  font-size: 12px;
`;

export const StyledNumber = styled.span`
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: block;
  position: relative;
  box-sizing: border-box;
  box-shadow: inset 0 0 0 2px transparent;
  svg {
    display: block;
    width: 25px;
    height: 25px;
  }
  .__react_component_tooltip {
    font-weight: 500;
  }
  ${({ feeling }) => {
    if (feeling === -1) {
      return css`
        box-shadow: inset 0 0 0 2px #d9d9d9;
      `;
    }
    if (feeling === 0) {
      return css`
        box-shadow: inset 0 0 0 2px #cc392d;
      `;
    }
    if (feeling === 1) {
      return css`
        box-shadow: inset 0 0 0 2px #009568;
      `;
    }
  }}
`;

export const StyledSorted = styled(Sorted)`
  margin-bottom: -1px;
  margin-left: 5px;
  width: 10px;
  height: 12px;
  fill: ${({ theme }) => theme.textFaint};
  ${({ type }) => {
    if (type === 'fromMinToMax') {
      return css`
        path:first-of-type {
          display: none;
        }
      `;
    }
    if (type === 'fromMaxToMin') {
      return css`
        path:last-of-type {
          display: none;
        }
      `;
    }
  }}
`;

export const StyledInTeamIcon = styled.span`
  width: 6px;
  height: 6px;
  position: absolute;
  background-color: ${({ theme }) => theme.accent};
  border-radius: 50%;
  left: -10px;
`;

export const StyledStatusIcons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ $compact }) => ($compact ? 'flex-start' : 'center')};
  gap: 3px;
  min-width: ${({ $compact }) => ($compact ? '0' : '123px')};
  margin-left: ${({ $compact }) => ($compact ? '6px' : '0')};
  ${({ $card }) =>
    $card &&
    css`
      margin: 0;
      min-width: 0;
      gap: 6px;
      flex-wrap: wrap;
    `}
`;

export const StyledStatusIcon = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${({ color }) => color};
  color: #fff;
  flex-shrink: 0;
  line-height: 0;
  svg {
    display: block;
    width: 12px;
    height: 12px;
    flex-shrink: 0;
    fill: none;
    stroke: currentColor;
  }
`;

export const StyledStatusIconWrap = styled.span`
  position: relative;
  display: inline-flex;
`;

// A short text glyph (yellow card count) in place of an svg.
export const StyledStatusIconText = styled.span`
  font: 700 11px/1 Archivo, sans-serif;
  color: ${({ $color }) => $color || 'inherit'};
`;

export const StyledTableContainer = styled.section`
  width: 100%;
  overflow: auto;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.cardRadius};
  padding: 4px 12px 8px;
  @media screen and (max-width: 1199px) {
    background: transparent;
    border: 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-style: none;
  overflow: hidden;
  @media screen and (max-width: 1199px) {
    border-collapse: separate;
    max-width: 400px;
    border-spacing: 0 1em;
    [type='No'],
    [type='Age'],
    [type='Position'],
    [type='Rating'],
    [type='Fitness'],
    [type='Media Rating'],
    [type='Potential'], 
    [type='Contract left'],
    [type='Status'] {
      display: none;
    }
  }
`;

export const StyledThead = styled.thead`
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  ${({ display }) => {
    if (display === 'none')
      return css`
        display: none;
      `;
  }}
`;

export const StyledTbody = styled.tbody`
  /* border-top: 12px solid #e5e5e5; */
  &::before {
    content: '';
    display: block;
    height: 0px;
  }
`;

export const StyledTrTh = styled.tr``;

export const StyledTh = styled.th`
  padding: 12px 8px;
  background: transparent;
  font-family: 'Archivo', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 1.2;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.textFaint};
  vertical-align: middle;
  white-space: nowrap;
  &[type='Lifetime Matches'] {
    max-width: 90px;
  }
  &[type='Media Rating'] {
    text-align: center;
    padding-left: 8px;
    padding-right: 8px;
    span {
      display: none;
    }
  }
  &[type='No'] {
    font-size: 0;
    span {
      display: none;
    }
  }
  &[type='Status'] {
    font-size: 0;
    width: 126px;
    padding: 12px 4px;
    span {
      display: none;
    }
  }
  @media screen and (max-width: 400px) {
    font-size: 11px;
  }

  &:first-of-type {
    border-top-left-radius: 9px;
    border-bottom-left-radius: 0px;
  }
  &:last-of-type {
    border-top-right-radius: 9px;
    border-bottom-right-radius: 0px;
  }
  ${({ display, titleNumberName, type }) => {
    if (titleNumberName)
      return css`
        display: none;
      `;
    if (display === 'none')
      return css`
        display: none;
      `;
    if (type === 'Name') {
      return css`
        text-align: left;
        padding-left: 20px;
      `;
    }
  }}
`;

export const StyledTitle = styled.span`
  font-family: 'Archivo', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: normal;
  display: flex;
  align-items: center;
  flex-direction: row;
  position: relative;
  color: ${({ theme }) => theme.text};
`;

export const StyledTrTd = styled.tr`
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  background: transparent;
  @media only screen and (max-width: 1199px) {
    border: 0;
    border-radius: ${({ theme }) => theme.cardRadius};
    background: ${({ theme }) => theme.card};
  }
  &:hover {
    cursor: pointer;
    background: ${({ theme }) => theme.hover};
  }
  &.clicked {
    cursor: pointer;
    background: ${({ theme }) =>
      theme.isDark ? 'rgba(14, 74, 251, 0.24)' : 'rgba(14, 74, 251, 0.12)'};
  }

  ${({ clicked, theme }) => css`
    &.row-number-${clicked} {
      background: ${theme.isDark
        ? 'rgba(14, 74, 251, 0.24)'
        : 'rgba(14, 74, 251, 0.12)'};
      td {
        color: ${theme.text};
        ${StyledCell} {
          color: ${theme.text};
        }
      }
    }
  `}

  &:last-of-type {
    border-bottom: 0;
    @media only screen and (max-width: 1199px) {
      td {
        &:first-child {
          border-bottom-left-radius: 16px;
        }
        &:last-child {
          border-bottom-right-radius: 16px;
        }
      }
    }
  }
`;

export const StyledTd = styled.td`
  text-align: center;
  padding: 10px 8px;
  font-family: 'Archivo', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: ${({ isLoaned, theme }) => (isLoaned ? theme.textFaint : theme.text)};
  width: auto;
  line-height: 1.2;
  vertical-align: middle;
  &[type='Media Rating'] {
    text-align: center;
    padding: 8px;
    width: 148px;
    ${({ isLoaned }) => {
    if (isLoaned) {
      return css`
          filter: grayscale(100%);
        `;
    }
  }}
  }

  &[type='No'] {
    width: 44px;
  }
  &[type='Status'] {
    width: 126px;
    padding: 8px 4px;
  }
  &[type='Name'] {
    ${({ isLoaned, theme }) => {
    if (isLoaned) {
      return css`
          color: ${theme.textFaint};
        `;
    }
  }}
  }
  &[type='Contract left'] {
    white-space: nowrap;
    width: 110px;
  }
  &[type='Lifetime Matches'] {
    max-width: 80px;
  }
  ${({ titleCell, type }) => {
    if (titleCell)
      return css`
        text-align: left;
      `;
    if (type === 'PTS') {
      return css`
        span {
          background: rgba(14, 74, 251, 0.1);
          border: 1px solid rgba(187, 199, 234, 0.45);
          border-radius: 5px;
          padding: 0 11px;
        }
      `;
    }
    if (type === 'NO') {
      return css`
        width: 60px;
        opacity: 0.5;
      `;
    }
    if (type === 'Name') {
      return css`
        text-align: left;
        padding-left: 20px;
      `;
    }
  }}
  @media screen and (max-width: 1199px) {
    padding: 10px 0;
    border-radius: 9px;
  }
`;

export const StyledRatingCell = styled.div`
  position: relative;
  width: 120px;
  margin: 0 auto;
  ${({ isLoaned, theme }) => {
    if (isLoaned) {
      return css`
        polygon {
          fill: ${theme.textFaint};
        }
      `;
    }
  }}
  @media (max-width: 530px) {
    width: 100px;
  }
`;

export const StyledRowNumber = styled.span`
  max-width: 50px;
`;

export const StyledLifetimeCell = styled.div`
  position: relative;
  margin: 0 auto;
`;

export const StyledChartContainer = styled.div`
  padding: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 2px;
`;

export const StyledSelect = styled(Select)`
  background-color: transparent;

  font-size: 13px;
  .react-select__control {
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.06));
    min-height: 25px;
    background-color: transparent;
    border: 0;
    font-weight: 700;
    box-shadow: none;
  }

  .react-select__placeholder {
    font-family: 'Archivo', sans-serif;
    line-height: 20px;
    font-weight: 500;
    letter-spacing: 0px;
    color: ${({ theme }) => theme.textFaint};
  }
  .react-select__single-value {
    color: ${({ theme }) => theme.text};
  }
  ${themedSelectMenuCss}
  .react-select__option {
    font-family: 'Archivo', sans-serif;
    padding: 8px 10px;
  }
  .react-select__indicator {
    padding: 0;
    position: relative;
    svg {
      display: none;
    }
    &:before {
      display: block;
      content: ' ';
      width: 0;
      height: 0;
      opacity: 0.5;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;

      border-top: 4px solid ${({ theme }) => theme.text};
    }
  }
  .react-select__value-container {
    width: 30px;
    padding: 3px;
  }
  .react-select__indicator-separator {
    display: none;
  }
`;

export const StyledSelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  span {
    font-size: 13px;
  }
`;

export const StyledPagination = styled.div`
  display: flex;
  flex-direction: row;
  height: 25px;
  justify-content: flex-end;
  margin-top: 30px;
  z-index: 100;
`;

export const ArrowRight = styled.i`
  border: solid ${({ theme }) => theme.text};
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
`;
export const ArrowLeft = styled.i`
  border: solid ${({ theme }) => theme.text};
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 2px;
  transform: rotate(-225deg);
`;

export const StyledPaginationButton = styled.button`
  border: 0;
  box-shadow: none;
  background-color: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text};
  border-radius: 6px;
  align-self: center;
  display: flex;
  flex-direction: row;
  width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`;
export const StyledPageNumber = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 20px;
`;

export const StyledPageLabel = styled.span`
  font-size: 13px;
  margin: 0 10px;
  color: ${({ theme }) => theme.text};
`;

export const StyledReactTooltip = styled(ThemedTooltip)`
  box-shadow: 0 0 15px 5px rgba(17, 17, 17, 0.08);
  font-family: Archivo;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.card};
  width: 190px;
  &.__react_component_tooltip.show {
    color: ${({ theme }) => theme.text};
    font-size: 13px;
    line-height: 18px;
    border-radius: 6px;
    opacity: 1;
  }
`;

export const StyledTooltipContainer = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
`;

export const StyledTopSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  padding: 10px 15px;
  position: relative;
  ${({ feeling }) => {
    if (feeling === -1) {
      return css`
        &:after {
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 10px 10px 0 0;
          border-color: #d9d9d9 transparent transparent transparent;
          top: -10px;
          left: 0;
        }
      `;
    }
    if (feeling === 0) {
      return css`
        &:after {
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 10px 10px 0 0;
          border-color: #cc392d transparent transparent transparent;
          top: -10px;
          left: 0;
        }
      `;
    }
    if (feeling === 1) {
      return css`
        &:after {
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 10px 10px 0 0;
          border-color: #009568 transparent transparent transparent;
          top: -10px;
          left: 0;
        }
      `;
    }
  }}
`;

export const StyledBottomSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 15px;
`;

export const StyledMobileSection = styled.div`
  font-family: 'Archivo', sans-serif;
  font-style: normal;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 11px;
  text-align: center;
`;

export const StyledSortSelect = styled(Select)`
  display: none;
  @media only screen and (max-width: 1199px) {
    display: flex;
    width: 100%;
  }
  .react-select__control {
    background-color: ${({ theme }) => theme.card};
    color: ${({ theme }) => theme.text};
    border: 1px solid ${({ theme }) => theme.border};
    width: 100%;
  }
  .react-select__indicator-separator {
    display: none;
  }
  .react-select__menu {
    z-index: 8;
  }
  .react-select__single-value {
    color: ${({ theme }) => theme.text};
  }

  .react-select__placeholder {
    font-family: 'Archivo', sans-serif;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.textFaint};
  }
  ${themedSelectMenuCss}
  ${({ $toolbar, theme }) =>
    $toolbar &&
    css`
      display: flex;
      height: 40px;
      .react-select__control {
        min-height: 40px;
        height: 40px;
        border-radius: ${theme.controlRadius};
        border: 1px solid ${theme.border};
        background: ${theme.card};
        box-shadow: none;
        font-family: 'Archivo', sans-serif;
        font-size: 13px;
        font-weight: 600;
      }
      .react-select__value-container {
        padding: 0 4px 0 12px;
        height: 40px;
      }
      .react-select__single-value,
      .react-select__placeholder {
        font-size: 13px;
        font-weight: 600;
        color: ${theme.text};
      }
      .react-select__indicators {
        height: 40px;
      }
      .react-select__indicator {
        padding: 0 8px;
        svg {
          fill: ${theme.text};
        }
      }
      .react-select__menu {
        z-index: 12;
      }
    `}
`;

export const StyledSortContainer = styled.div`
  display: ${({ $toolbar }) => ($toolbar ? 'flex' : 'none')};
  @media only screen and (max-width: 1199px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    max-width: 400px;
    margin: 0 auto;
  }
  ${({ $toolbar }) =>
    $toolbar &&
    css`
      max-width: none;
      margin: 0;
      width: 100%;
      height: 40px;
      padding: 0;
      background: transparent;
      border: 0;
    `}
`;
export const SortLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  font-family: 'Archivo', sans-serif;
  color: ${({ theme }) => theme.text};
`;

export const StyledTableCell = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  font-family: 'Archivo', sans-serif;
`;
